function hideAllTooltips () {
  $('.tooltip.show').remove();
}

function stopEvent (e) {
  e.preventDefault();
  e.stopPropagation();
  e.stopImmediatePropagation();
  return false;
}

function setCookie (key, value, expires) {
  expires = expires || 86400;
  Cookies.set(key, value, { expires: expires, path: $body.data('baseUrl') });
}

function getCookie (key) {
  return Cookies.get(key);
}

function delCookie (key) {
  return Cookies.expire(key, { path: $body.data('baseUrl') });
}

jQuery(function ($) {
  window.$window = $(window);
  window.$body = window.$body || $('body');
  window.controller = $body.data('controller');
  window.action = $body.data('action');

  $(document).ajaxComplete(function (event, request) {
    var toasts = request['responseJSON'] || {};
    toasts = toasts['toasts'] || {};

    $.each(toasts, function (type, message) {
      toastr[type](message);
    });
  });
});
